import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=316d4c1e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316d4c1e"]])

export default __exports__